if ( typeof customElements.get('shipping-notice') === 'undefined' ) {
  customElements.define('shipping-notice', class extends HTMLElement {
    connectedCallback() { this.render(); }
    render() {
      var threshold = Number(this.getAttribute('data-free-shipping'));
      var cartTotal = Number(this.getAttribute('data-cart-total-amount'));
      var rate = (window.Shopify && Shopify.currency && Shopify.currency.rate) ? Number(Shopify.currency.rate) : 1;
      var goal = Math.round(threshold * rate);
      var remaining = goal - cartTotal;
      var pct = goal > 0 ? Math.min(100, Math.max(0, (cartTotal / goal) * 100)) : 100;
      var isJA = (document.documentElement.getAttribute('lang') || '').toLowerCase().indexOf('ja') === 0;
      var success = remaining <= 0;
      var message;
      if ( success ) {
        message = isJA ? '送料無料が適用されます 🎉' : 'Free shipping unlocked 🎉';
      } else {
        var yen = '¥' + Math.round(remaining / 100).toLocaleString('en-US');
        message = isJA ? ('あと ' + yen + ' で送料無料') : ("You're " + yen + ' away from free shipping');
      }
      if ( !document.getElementById('swirl-fsbar-style') ) {
        var st = document.createElement('style');
        st.id = 'swirl-fsbar-style';
        st.textContent = 'shipping-notice{display:block;background:#ffffff}.swirl-fsbar{margin:0;padding:13px 16px;font-size:13.5px;line-height:1.35;background:#ffffff}.swirl-fsbar__msg{margin:0 0 7px;color:#211f1d;font-weight:600;text-align:center}.swirl-fsbar.is-ok .swirl-fsbar__msg{color:#086352}.swirl-fsbar__track{height:8px;background:#e7efec;border-radius:99px;overflow:hidden}.swirl-fsbar__fill{display:block;height:100%;background:linear-gradient(90deg,#0d8f74,#086352);border-radius:99px;transition:width .35s ease}';
        document.head.appendChild(st);
      }
      this.style.display = 'block';
      this.style.background = '#ffffff';
      this.innerHTML = '<div class="swirl-fsbar' + (success ? ' is-ok' : '') + '"><p class="swirl-fsbar__msg">' + message + '</p><div class="swirl-fsbar__track"><span class="swirl-fsbar__fill" style="width:' + pct + '%"></span></div></div>';
    }
  });
}
